import { create } from 'zustand';

interface DepositModalStore {
	isOpen: boolean;
	emptyBalance: boolean;
	openDepositModal: (emptyBalance?: boolean) => void;
	closeDepositModal: () => void;
}

export const useDepositModalStore = create<DepositModalStore>((set) => ({
	isOpen: false,
	emptyBalance: false,
	openDepositModal: (emptyBalance = false) => set({ isOpen: true, emptyBalance }),
	closeDepositModal: () => set({ isOpen: false, emptyBalance: false }),
}));
